import React, { useState } from 'react';
import { db } from '../firebase'; 
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import '../App.css';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false); // Popup state

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // ഡാറ്റ അയക്കുന്നത് വേഗത്തിലാക്കാൻ serverTimestamp നേരിട്ട് നൽകുന്നു
      await addDoc(collection(db, "contacts"), {
        ...formData,
        submittedAt: serverTimestamp()
      });

      setShowPopup(true); // സക്സസ് പോപ്പ്അപ്പ് കാണിക്കുന്നു
      setFormData({ name: '', email: '', phone: '', message: '' });
    } catch (error) {
      console.error("Error saving document: ", error);
      alert("Oops! Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      {/* Success Popup Modal */}
      {showPopup && (
        <div className="custom-popup-overlay">
          <div className="custom-popup">
            <div className="success-icon">
              <i className="fas fa-check-circle"></i>
            </div>
            <h2>Message Sent!</h2>
            <p>Thank you for contacting MR WHITE. We have received your message and will get back to you shortly.</p>
            <button onClick={() => setShowPopup(false)} className="btn-close-popup">Great!</button>
          </div>
        </div>
      )}

      {/* Hero Section */}
      <section className="contact-hero">
        <div className="hero-overlay">
          <div className="hero-content">
            <h1>Get In <span>Touch</span></h1>
            <p>Have a question or need a pickup? We're here to help you 24/7.</p>
          </div>
        </div>
      </section>

      {/* Contact Form & Info Section */}
      <section className="contact-main">
        <div className="contact-grid">
          
          <div className="contact-form-wrapper">
            <h3>Send Us a Message</h3>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <input 
                  type="text" 
                  name="name"
                  placeholder="Your Name" 
                  value={formData.name}
                  onChange={handleChange}
                  required 
                />
              </div>
              <div className="form-group">
                <input 
                  type="email" 
                  name="email"
                  placeholder="Email Address" 
                  value={formData.email}
                  onChange={handleChange}
                  required 
                />
              </div>
              <div className="form-group">
                <input 
                  type="text" 
                  name="phone"
                  placeholder="Phone Number" 
                  value={formData.phone}
                  onChange={handleChange}
                  required 
                />
              </div>
              <div className="form-group">
                <textarea 
                  name="message"
                  placeholder="How can we help you?" 
                  rows="5" 
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>
              <button type="submit" className="btn-submit" disabled={loading}>
                {loading ? "Sending..." : "Send Message"}
              </button>
            </form>
          </div>

          <div className="contact-info-wrapper">
            <h3>Contact Details</h3>
             {  
            <div className="info-item">
              <div className="info-icon"><i className="fas fa-map-marker-alt"></i></div>
              <div className="info-text">
                <h4>Our Location</h4>
            <p>Ajman - United Arab Emirates</p> 
              </div>
            </div>

            }

            <div className="info-item">
              <div className="info-icon"><i className="fas fa-phone-alt"></i></div>
              <div className="info-text">
                <h4>Call Us</h4>
                <p>+971 58 577 9343</p>
              </div>
            </div>

            <div className="info-item">
              <div className="info-icon"><i className="fas fa-envelope"></i></div>
              <div className="info-text">
                <h4>Email Us</h4>
                <p>customercare@mrwhiteuae.com</p>
              </div>
            </div>

            <div className="social-links-contact">
              <a href="#!"><i className="fab fa-facebook-f"></i></a>
              <a href="#!"><i className="fab fa-instagram"></i></a>
              <a href="#!"><i className="fab fa-whatsapp"></i></a>
            </div>
          </div>
        </div>
      </section>

      
    </div>
  );
}

export default Contact;